// extracted by mini-css-extract-plugin
module.exports = {"tableHeadCell":"TableHeadCell_tableHeadCell__272E0"};